import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Check, X, Search, Calendar } from "lucide-react";
import axios from "axios";

let PREDEFINED_BLAST_OPTIONS = [];

const BlastSelectionModal = ({
  isOpen = false,
  onClose,
  selectedBlasts = [],
  onBlastSelection,
  setOreFile,
  setModal,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredBlasts, setFilteredBlasts] = useState(
    PREDEFINED_BLAST_OPTIONS
  );
  const [oreFileUrl, setOreFileUrl] = useState(null);
  const [loader, setLoader] = useState(true);
  const [oreLoad, setOreLoad] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (!isOpen) {
      setSearchTerm("");
      setFilteredBlasts(PREDEFINED_BLAST_OPTIONS);
      const currentDate = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      setFromDate(oneMonthAgo.toISOString().split("T")[0]);
      setToDate(currentDate.toISOString().split("T")[0]);

      const fetchData = async () => {
        try {
          const response = await fetch(
            "https://ks2uwnzkrxhmzmfdis44invevu0pooae.lambda-url.ap-southeast-2.on.aws/retriveblastrecord/" +
              fromDate +
              "/" +
              toDate
          );
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const result = await response.json();
          setFilteredBlasts(result);
          PREDEFINED_BLAST_OPTIONS = result;
          setLoader(false);
        } catch (error) {
          console.error(error);
        } finally {
          console.log("");
        }
      };
      fetchData();
    }
  }, [isOpen]);

  const filterSearch = (val) => {
    setSearchTerm(val);
    if (val == "") {
      setFilteredBlasts(PREDEFINED_BLAST_OPTIONS);
    } else {
      const filterData = filteredBlasts.filter((blast) =>
        blast.DesignCode.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredBlasts(filterData);
    }
  };

  const handleSearch = async () => {
    setLoader(true);
    try {
      const response = await fetch(
        "https://ks2uwnzkrxhmzmfdis44invevu0pooae.lambda-url.ap-southeast-2.on.aws/retriveblastrecord/" +
          fromDate +
          "/" +
          toDate
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setFilteredBlasts(result);
      PREDEFINED_BLAST_OPTIONS = result;
      setLoader(false);
    } catch (error) {
      console.log(error);
    } finally {
      console.log("");
    }
  };

  const handleBlastToggle = (blastId) => {
    const updatedSelection = selectedBlasts.includes(blastId)
      ? selectedBlasts.filter((id) => id !== blastId)
      : [...selectedBlasts, blastId];
    onBlastSelection(updatedSelection);
  };
  const applySelection = async () => {
    setOreLoad(true);
    let OreFile = [];
    for (let i = 0; i < selectedBlasts.length; i++) {
      try {
        const response = await fetch(
          "https://ks2uwnzkrxhmzmfdis44invevu0pooae.lambda-url.ap-southeast-2.on.aws/retriveblastrecord/" +
            selectedBlasts[i]
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        OreFile.push(JSON.parse(result.FileLocation).DroneFilePath.Ore);
      } catch (error) {
        console.log(error);
      } finally {
        console.log("");
      }
    }
    setOreFileUrl(OreFile);
    setOreFile(OreFile);
    if (!window.apiData) window.apiData = {};
    localStorage.setItem("planfilelocation", JSON.stringify(OreFile));
    window.apiData.planfilelocation = JSON.stringify(OreFile);
    await updateStopeDetail();
    setOreLoad(false);
    setModal(false);
  };
  const updateStopeDetail = async () => {
    try {
      const response = await axios.post(
        API_BASE_URL + "/stopescannedresultinsertupdate",
        JSON.stringify(window.apiData),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">
            Select Blast Data
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-4">
          {/* Search Input */}
          <div className="relative mb-4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search blast data..."
              value={searchTerm}
              onChange={(e) => filterSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Date Filters */}
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>

          {/* Search Button */}
          <button
            onClick={handleSearch}
            className="w-full py-2 mb-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Search
          </button>
          {loader && (
            <div role="status" className="max-w-sm animate-pulse">
              <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
              <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
              <span className="sr-only">Loading...</span>
            </div>
          )}

          {loader === false && (
            <div className="space-y-3 max-h-64 overflow-y-auto">
              {filteredBlasts.map((blast) => (
                <div
                  key={blast.Designid}
                  onClick={() => handleBlastToggle(blast.Designid)}
                  className="flex items-center p-3 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div
                    className={`
                    w-5 h-5 rounded border mr-3 flex items-center justify-center transition-colors
                    ${
                      selectedBlasts.includes(blast.Designid)
                        ? "bg-blue-600 border-blue-600"
                        : "border-gray-300"
                    }
                  `}
                  >
                    {selectedBlasts.includes(blast.Designid) && (
                      <Check className="w-3 h-3 text-white" />
                    )}
                  </div>
                  <div className="flex-1">
                    <div className="text-gray-900 font-medium">
                      {blast.DesignCode}
                    </div>
                    <div className="text-sm text-gray-500">
                      Date: {blast.CreationDateTime.split("T")[0]}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-between items-center">
          <div className="text-sm text-gray-500">
            {selectedBlasts.length} blast
            {selectedBlasts.length !== 1 ? "s" : ""} selected
          </div>
          <div className="flex space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
            >
              Cancel
            </button>
            {oreLoad && (
              <div className="w-12 h-12 border-8 border-dashed rounded-full animate-spin border-blue-600"></div>
            )}
            {oreLoad === false && (
              <button
                onClick={applySelection}
                className={`px-4 py-2 text-sm font-medium text-white rounded-md transition-colors ${
                  selectedBlasts.length > 0
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                disabled={selectedBlasts.length === 0}
              >
                Apply Selection
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlastSelectionModal;
